import {
  GET_REVISIONS,
  GET_REVISIONS_SUCCESS,
  GET_REVISIONS_FAILURE,
  SET_REVISION_STEP,
  SET_REVISION_FIELDS,
} from "./constants";

export const getRevisions = (payload, callback) => ({
  type: GET_REVISIONS,
  payload,
  callback,
});
export const getRevisionsSuccess = (payload) => ({
  type: GET_REVISIONS_SUCCESS,
  payload,
});
export const getRevisionsFailure = (payload) => ({
  type: GET_REVISIONS_FAILURE,
  payload,
});

export const setRevisionStep = (payload) => ({
  type: SET_REVISION_STEP,
  payload,
});
export const setRevisionFields = (payload) => ({
  type: SET_REVISION_FIELDS,
  payload,
});
